export const ITALY_TO_INDIA_LABEL = "Indian imports from Italy";
export const INDIA_TO_ITALY_LABEL = "Italian imports from India";

export const COUNTRY_FILTER_VALUES = {
  italyImportsFromIndia: "italy_imports_from_india",
  indiaImportsFromItaly: "india_imports_from_italy",
};
